import { Component, _decorator } from 'cc';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import Lobby from '../../../System/Lobby';
import { FeatureActivityEventName } from '../../Data/Config/FeatureActivityConfig';

declare module '../../../../common/scripts/Toolkit/Components/Page/Page' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    export default interface Page {
        title: string;
    }
}

Page.INSTANCES.push = function push(...items: Page[]) {
    items.forEach((item) => {
        const pageTitle = item.getComponent(PageTitle);
        if (pageTitle) {
            item.on(Page.EVENT_TYPE.CLOSE_END, () => {
                Lobby.activity.send(FeatureActivityEventName.ClosePage, { PageTitle: pageTitle.title });
            });
        }
    });
    return Array.prototype.push.apply(this, items);
};

const { ccclass, property, requireComponent } = _decorator;

@ccclass('PageTitle')
@requireComponent(Page)
export default class PageTitle extends Component {
    @property
    public readonly title: string = '';

    private _page: Page = null;

    private get page(): Page {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    protected onLoad(): void {
        this.page.title = this.title;
    }
}
